/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Happy_Robin_PetInputs */

const fr_fair_happy_robin_pet = /** @type {(inputs: Fair_Happy_Robin_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouve ici tous les programmes auxquels tu as accès`)
};

/**

* @param {Fair_Happy_Robin_PetInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fair_happy_robin_pet = /** @type {((inputs?: Fair_Happy_Robin_PetInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Happy_Robin_PetInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fair_happy_robin_pet(inputs)
});